import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QUERY_KEY_CONTACTS } from "../../common/Constants";
import { updateContactByIdMutation } from "../../generated/client/octalog-service/@tanstack/react-query.gen";
import { useBaseMutation } from "../../hooks/useBaseMutation";

export const useUpdateContactMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    useBaseMutation({
      ...updateContactByIdMutation(),
      successMessage: "Der Kontakt wurde erfolgreich aktualisiert.",
      errorMessage: "Der Kontakt konnte nicht aktualisiert werden",
      onSuccess: () => {
        // noinspection JSIgnoredPromiseFromCall
        queryClient.invalidateQueries({
          queryKey: QUERY_KEY_CONTACTS,
        });
      },
    }),
  );
};
